var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ResearchGalleryPage',{attrs:{"page-title":"行政管理工作","section-label":"科研保障","section-route":_vm.sectionRoute,"top-strip-image":_vm.topStripImage,"hero-background-image":_vm.heroBackgroundImage,"groups":_vm.groups}})
}
var staticRenderFns = []

export { render, staticRenderFns }